export default class VehicleTradeproposal {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.inputs = this.DOM.el.querySelectorAll('[data-vehicle-tradeproposal-input]');
        this.DOM.button = this.DOM.el.querySelector('[data-vehicle-tradeproposal-button]');

        this.initEvents();
    }

    initEvents() {
        /* Add event listeners */
        if (this.DOM.inputs) {
            const queryParams = {};
            this.DOM.inputs.forEach((element) => {
                element.addEventListener("change", (e) => {
                    queryParams[element.getAttribute('data-vehicle-tradeproposal-input-name')] = e.target.value;
                    this.DOM.button?.setAttribute('data-flow-query-params', JSON.stringify(queryParams));
                });
            });
        }
    }
}

const vehicleTradeproposalNodes = Array.from(document.querySelectorAll('[data-vehicle-tradeproposal]'));
if (vehicleTradeproposalNodes !== null) {
    vehicleTradeproposalNodes.forEach((node) => { new VehicleTradeproposal(node); });
}
